import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=7ccff41b"
import script from "./LoginButton.js?vue&type=script&lang=js&external"
export * from "./LoginButton.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports